module.exports = __webpack_public_path__ + "static/media/goat-breaking-open-a-pumpkin.0d2bafbc.gif";